/**
 * update item in array using id
 * if not found, create the item
 * @param arr - item array
 * @param nextItem  - item to be updated / created
 * @param onlyUpdate - only update if exists, do not create
 */
export default function updateOrCreateItemInArray<
  T extends { id: string; [key: string]: any },
>(arr: T[], nextItem: Partial<T>, onlyUpdate?: boolean): T[] {
  const itemId = arr.findIndex((el) => el.id === nextItem.id);

  if (itemId < 0) {
    if (onlyUpdate) {
      return arr;
    }

    return [...arr, nextItem as T];
  }

  return [
    ...arr.slice(0, itemId),
    { ...arr[itemId], ...nextItem },
    ...arr.slice(itemId + 1),
  ];
}
